module.exports = __webpack_public_path__ + "media/images/games/k2gender/playingvideogames-d35a92473914daeb0e192c07c815d5d6.png";